module.exports = __webpack_public_path__ + "images/a315e17a661c078a8109212b5302f0d7-logo-fr.png";